import Typography from '@mui/material/Typography';
import { Sites } from '@ps/platform-message-framework/common/Sites';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useForm } from 'react-final-form';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import trScreenVideo from '../../../../assets/video/tr-screen-video.mp4';
import trVideoMobile from '../../../../assets/video/tr-video-mobile.mp4';
import Prompt from '../../../Prompt/Prompt';

import {
  TXTCLI_Extra_verification_required,
  TXTCLI_Thanks,
  TXTCLI_Verify_account,
  TXTWCL_Almost_there,
  TXTWCL_Check_my_details,
  TXTWCL_Continue_to_deposit,
  TXTWCL_Deposit_without_verifying,
  TXTWCL_Please_check_that_all_the_pers_ELL,
  TXTWCL_Please_check_that_all_the_pers_ELL_1,
  TXTWCL_Upload_ID,
  TXTWCL_Upload_Later,
  TXTWCL_We_are_having_trouble_verifyin_ELL,
  TXTWCL_We_just_need_you_to_submit_doc_ELL,
  TXTWCL_Your_details_have_been_savedX__ELL_1
} from './RMFEKYCTransitionScreen.messages.json';

export interface Props {
  transitionType: 'checkDetails' | 'documentVerification';
  showVerifications?: () => void;
}

const RMFEKYCTransitionScreen: React.FC<Props> = ({ transitionType, showVerifications }) => {
  const form = useForm();
  const isMobile = useSelector(select.device.isMobile);
  const video = isMobile ? trVideoMobile : trScreenVideo;
  const siteId = useSelector(select.cms.getSiteId);
  const isDe = siteId === Sites.DE;
  const isCAON = siteId === Sites.CA_ON;

  const props = {
    checkDetails: {
      title: isDe ? { translation: TXTCLI_Thanks } : { translation: TXTWCL_Almost_there },
      primaryButton: { translation: TXTWCL_Check_my_details }
    },
    documentVerification: {
      title: {
        translation: isDe ? TXTCLI_Thanks : TXTCLI_Extra_verification_required
      },
      primaryButton: { translation: isCAON ? TXTWCL_Upload_ID : TXTCLI_Verify_account },
      onPrimaryButtonClick: () => {
        showVerifications?.();
      },
      secondaryButton: {
        translation: isDe
          ? TXTWCL_Deposit_without_verifying
          : isCAON
            ? TXTWCL_Upload_Later
            : TXTWCL_Continue_to_deposit
      },
      onSecondaryButtonClick: () => {
        form.submit();
      }
    }
  };
  const content = {
    checkDetails: (
      <>
        <Translation {...TXTWCL_We_are_having_trouble_verifyin_ELL} />
        <Translation
          {...(isDe
            ? TXTWCL_Please_check_that_all_the_pers_ELL_1
            : TXTWCL_Please_check_that_all_the_pers_ELL)}
        />
      </>
    ),
    documentVerification: (
      <Translation
        {...(isDe
          ? TXTWCL_Your_details_have_been_savedX__ELL_1
          : TXTWCL_We_just_need_you_to_submit_doc_ELL)}
      />
    )
  };

  return (
    <Prompt noCloseButton variant="info" video={video} {...props[transitionType]}>
      <Typography>{content[transitionType]}</Typography>
    </Prompt>
  );
};

export default RMFEKYCTransitionScreen;
